import { useState, useEffect } from 'react';

const useFetchFilter = (filterId, storeId = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const url = `${
    process.env.RAZZLE_MAGENTO_URL
  }/rest/${storeId}/V1/products/attributes/${filterId}`;

  const fetchOptions = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  };

  async function fetchData() {
    const response = await fetch(url, fetchOptions);
    const json = await response.json();

    const filter = {
      label: json.default_frontend_label,
      options: json.options.filter(option => option.value.length),
      paramsKey: json.default_frontend_label.replace('Filter: ', '')
    };

    setData(filter);
    setLoading(false);
  }

  useEffect(
    () => {
      if (!loading) {
        setLoading(true);
      }
      if (storeId) {
        fetchData();
      }
    },
    [filterId, storeId]
  );

  return { loading, data };
};

export default useFetchFilter;
